(function ($) {
  'use strict';

  if (!window.matchMedia) {
    return;
  }

  var $pageHeader;
  var pageHeaderHeight;

  $(document).ready(init);

  function init() {
    var mql = window.matchMedia('(min-width: 55.5em)');

    $pageHeader = $('.page-header');
    pageHeaderHeight = $pageHeader.height() - $pageHeader.find('.region-navbar').height();

    if (mql.addListener) {
      mql.addListener(handleMatchMediaChange);
    }
    handleMatchMediaChange(mql);
  }

  function handleMatchMediaChange(mql) {
    if (mql.matches) {
      $(window).on('scroll', handleStickiness);
    }
    else {
      $(window).off('scroll', handleStickiness);
    }
  }

  function handleStickiness() {
    if ($(window).scrollTop() > pageHeaderHeight) {
      $pageHeader.addClass('page-header--sticky');
    }
    else {
      $pageHeader.removeClass('page-header--sticky');
    }
  }

})(jQuery);
